import React, { useState } from 'react';
import { Button, Divider, Spin, Typography } from 'antd';
import { useSelector } from 'react-redux';
import { useLocation } from '@reach/router';

import { useFetchAccountOptions } from '../../../../api/actions/useFetchAccountOptions';
import selectors from '../../../../store/selectors';
import BackToHomeButton from '../../../BackToHomeButton/BackToHomeButton';

const DeathPrayersConfirmation = () => {
  const parishData = useSelector(selectors.getAccountData);
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(false);

  // Recurring Donation Announcement data
  const accountIdsToShowRecurringDonationAnnouncement = [
    // '1395773119405883392', // Parafia św. Michała Archanioła Warszawa-Grodzisk
    '1353006595847266304', // Opactwo Benedyktynów w Tyńcu
    // '1232003310810333184', // Parafia św. Michała Archanioła Warszawa
    // '1523340304298192896', // Klasztor Zakonu Braci Mniejszych Kapucynów w Krakowie
    '654463132773478400', // Parafia Demo
    '1516868980247126016', // Parafia Demonstracyjna
    // '1461007000884875264', // Miłosierdzie Myślibórz
  ];
  const shouldShowRecurringDonationAnnouncement =
    accountIdsToShowRecurringDonationAnnouncement.includes(parishData.accountId);

  const accountSlug = location.pathname.split('/')[1];
  const recurringDonationFormUrl = `https://parafio.pl/${accountSlug}`;
  const isFetchingAccountOptions = useFetchAccountOptions();
  const accountOptions = useSelector(selectors.getOptions);
  const isLoading = isFetchingAccountOptions || Object.keys(accountOptions).length === 0;

  return (
    <div className="text-center text-lg-left">
      <h3 id="donate-message">
        Serdeczne Bóg zapłać za Twoją ofiarę.
        <br />
        Dziękujemy i&nbsp;zapewniamy o&nbsp;modlitwie.
      </h3>
      <p>Potwierdzenie płatności otrzymasz od operatora w&nbsp;wiadomości email.</p>

      {shouldShowRecurringDonationAnnouncement && (
        <>
          <Divider />
          {isLoading ? (
            <Spin />
          ) : (
            <div className="text-center">
              <Button
                type="primary"
                size="large"
                href={recurringDonationFormUrl}
                target="_blank"
                rel="noreferrer"
                style={{ marginBottom: '16px' }}
              >
                Wesprzyj nas Cykliczną Ofiarą Online
              </Button>

              <Typography.Paragraph style={{ textAlign: 'left', marginBottom: '16px' }}>
                <strong>Cykliczna Ofiara Online</strong> to nowa, wygodna forma wsparcia dla
                wiernych, którzy korzystają z płatności bezgotówkowych. Umożliwia automatyczne,
                bezpieczne przekazywanie ofiary co miesiąc lub co tydzień (np. jako uzupełnienie
                ofiary gotówkowej podczas Mszy Świętej lub jako dodatkowe wsparcie wspólnoty).
              </Typography.Paragraph>

              <Button
                type="link"
                onClick={() => setIsExpanded(!isExpanded)}
                style={{ padding: 0, marginBottom: '16px' }}
              >
                Przeczytaj więcej czym jest&nbsp;<strong>Cykliczna Ofiara Online</strong>
              </Button>

              {isExpanded && (
                <div className="text-left" style={{ marginTop: '16px' }}>
                  <Typography.Title level={4}>
                    Czym jest <strong>Cykliczna Ofiara Online</strong>?
                  </Typography.Title>

                  <Typography.Paragraph>
                    W odpowiedzi na rozwijające się potrzeby naszej wspólnoty i zmieniające się
                    nawyki dotyczące korzystania z pieniądza, chcemy wprowadzić nową, wygodną opcję
                    dla wszystkich, którzy pragną wspierać naszą parafię online w sposób regularny
                    (np. jako uzupełnienie ofiary gotówkowej podczas Mszy Świętej lub jako dodatkowe
                    wsparcie wspólnoty).
                  </Typography.Paragraph>

                  <Typography.Paragraph>
                    <strong>Cykliczna Ofiara Online</strong> to proste rozwiązanie, które pozwala na
                    automatyczne przekazywanie darowizn bezpośrednio z Twojej karty płatniczej na
                    rzecz wspólnoty. Możesz wybrać, czy chcesz przekazywać ofiarę co tydzień czy co
                    miesiąc.
                  </Typography.Paragraph>

                  <Typography.Paragraph>
                    To nowoczesne rozwiązanie jest w pełni dobrowolne i zostało zaprojektowane z
                    myślą o zapewnieniu maksymalnej wygody oraz bezpieczeństwa. Wszystkie transakcje
                    są szyfrowane i realizowane zgodnie z najwyższymi standardami ochrony danych,
                    dzięki czemu możesz być spokojny o bezpieczeństwo swoich środków.
                  </Typography.Paragraph>

                  <Typography.Title level={5}>Jak to działa?</Typography.Title>
                  <ol>
                    <li>Naciśnij przycisk &quot;Wesprzyj nas Cykliczną Ofiarą Online&quot;;</li>
                    <li>
                      Wybierz sposób wsparcia:
                      <ul>
                        <li>tygodniowy lub miesięczny,</li>
                        <li>kwotę przekazywanej ofiary;</li>
                      </ul>
                    </li>
                    <li>
                      Wprowadź dane karty (danę są obsługiwane w bezpieczny i zaszyfrowany sposób)
                    </li>
                    <li>
                      Raz na tydzień lub raz na miesiąc, wybrana kwota zostanie automatycznie
                      pobrana jako ofiara na rzecz naszej wspólnoty;
                    </li>
                    <li>
                      W dowolnym momencie możesz zrezygnować z{' '}
                      <strong>Cyklicznej Ofiary Online</strong>.
                    </li>
                  </ol>
                </div>
              )}
            </div>
          )}
          <Divider />
        </>
      )}

      <BackToHomeButton />
    </div>
  );
};

export default DeathPrayersConfirmation;
